import React from 'react';
import { Calendar, Search, Wrench } from 'lucide-react';
export const ProcessStrip = () => {
  const steps = [{
    icon: Calendar,
    title: 'Book',
    description: 'Call or email to arrange your repair visit'
  }, {
    icon: Search,
    title: 'Diagnose',
    description: 'Our engineer identifies the fault on-site'
  }, {
    icon: Wrench,
    title: 'Repair',
    description: 'We fix the issue and test the appliance'
  }];
  return <div className="bg-white py-12" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <h2 className="text-3xl font-bold text-slate-800 text-center mb-12" data-id="element-162">
          How It Works
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-163">
          {steps.map((step, index) => <div key={index} className="relative" data-id="element-164">
              <div className="flex flex-col items-center text-center" data-id="element-165">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-4" data-id="element-166">
                  <step.icon className="w-10 h-10 text-blue-600" data-id="element-167" />
                </div>
                <div className="absolute top-10 left-1/2 w-full h-0.5 bg-blue-200 -z-10 hidden md:block last:hidden" data-id="element-168" />
                <h3 className="text-xl font-semibold text-slate-800 mb-2" data-id="element-169">
                  {step.title}
                </h3>
                <p className="text-slate-600" data-id="element-170">{step.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};